import React from 'react';
import PropTypes from 'prop-types';
import CommonModal from 'components/CommonModal';
import LoadingBar from 'components/LoadingBar';
import Divider, { dividerAbsolutePositionStyles } from 'components/Divider';
import Button from 'components/Button';

import './style.scss';

const LoadingModal = ({
  isOpen,
  isLoading,
  icon,
  description,
  title,
  onCancel,
}) => (
  <CommonModal
    body={
      <React.Fragment>
        {description}
        <LoadingBar color="blue" />
      </React.Fragment>
    }
    footer={
      <div styleName="modal-footer">
        <Button data-test="cancel-button" styleName="cancel" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    }
    header={
      <div styleName="modal-header">
        <div className={icon} data-test="header-icon" styleName="icon" />
        <div data-test="header-title" styleName="title">
          {title}
        </div>
        <Divider css={dividerAbsolutePositionStyles} />
      </div>
    }
    isLoading={isLoading}
    isOpen={isOpen}
  />
);

LoadingModal.propTypes = {
  description: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  icon: PropTypes.string,
};

LoadingModal.defaultProps = {
  icon: 'icon-deployment-export',
};

export default LoadingModal;
